/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HandlingUnitType } from './HandlingUnitType';
import {
    HandlingUnitTypeFromJSON,
    HandlingUnitTypeFromJSONTyped,
    HandlingUnitTypeToJSON,
    HandlingUnitTypeToJSONTyped,
} from './HandlingUnitType';
import type { TemperatureHandling } from './TemperatureHandling';
import {
    TemperatureHandlingFromJSON,
    TemperatureHandlingFromJSONTyped,
    TemperatureHandlingToJSON,
    TemperatureHandlingToJSONTyped,
} from './TemperatureHandling';

/**
 * Represents a line item
 * @export
 * @interface LineItem
 */
export interface LineItem {
    /**
     * 
     * @type {HandlingUnitType}
     * @memberof LineItem
     */
    handlingUnitType: HandlingUnitType;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    numberHandlingUnits: number;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    length: number;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    weightPerHandlingUnit: number;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    freightClass: string;
    /**
     * 
     * @type {TemperatureHandling}
     * @memberof LineItem
     */
    temperatureHandling: TemperatureHandling;
    /**
     * 
     * @type {boolean}
     * @memberof LineItem
     */
    isDangerous: boolean;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    nmfcItemNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LineItem
     */
    isStackable: boolean;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    lineItemId: string;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    dangerousUnNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    dangerousClassification?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    dangerousPackingGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    dangerousProperShippingName?: string;
    /**
     * The precise technical name of the material, providing more detailed identification beyond the proper shipping name.<br/>Optional. When the shipment picks up or delivers in Canada and the UN number carries TDG special provision 16, the technical name must appear on the bill of lading - supply it to keep the TDG declaration complete.
     * @type {string}
     * @memberof LineItem
     */
    dangerousTechnicalName?: string;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    dangerousNumberPackages?: number;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    dangerousPackagingType?: string;
    /**
     * Net explosive quantity in kilograms. Optional. For a Class 1 explosive (classification starts with 1) on a shipment that picks up or delivers in Canada, this must appear on the bill of lading - supply it when known. Must be greater than zero when provided; capped at the heaviest shipment we accept (48,000 lb).
     * @type {number}
     * @memberof LineItem
     */
    dangerousNetExplosiveQuantityKg?: number;
}



/**
 * Check if a given object implements the LineItem interface.
 */
export function instanceOfLineItem(value: object): value is LineItem {
    if (!('handlingUnitType' in value) || value['handlingUnitType'] === undefined) return false;
    if (!('numberHandlingUnits' in value) || value['numberHandlingUnits'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('length' in value) || value['length'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    if (!('weightPerHandlingUnit' in value) || value['weightPerHandlingUnit'] === undefined) return false;
    if (!('freightClass' in value) || value['freightClass'] === undefined) return false;
    if (!('temperatureHandling' in value) || value['temperatureHandling'] === undefined) return false;
    if (!('isDangerous' in value) || value['isDangerous'] === undefined) return false;
    if (!('isStackable' in value) || value['isStackable'] === undefined) return false;
    if (!('lineItemId' in value) || value['lineItemId'] === undefined) return false;
    return true;
}

export function LineItemFromJSON(json: any): LineItem {
    return LineItemFromJSONTyped(json, false);
}

export function LineItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineItem {
    if (json == null) {
        return json;
    }
    return {
        
        'handlingUnitType': HandlingUnitTypeFromJSON(json['handlingUnitType']),
        'numberHandlingUnits': json['numberHandlingUnits'],
        'description': json['description'],
        'length': json['length'],
        'width': json['width'],
        'height': json['height'],
        'weightPerHandlingUnit': json['weightPerHandlingUnit'],
        'freightClass': json['freightClass'],
        'temperatureHandling': TemperatureHandlingFromJSON(json['temperatureHandling']),
        'isDangerous': json['isDangerous'],
        'nmfcItemNumber': json['nmfcItemNumber'] == null ? undefined : json['nmfcItemNumber'],
        'isStackable': json['isStackable'],
        'lineItemId': json['lineItemId'],
        'dangerousUnNumber': json['dangerousUnNumber'] == null ? undefined : json['dangerousUnNumber'],
        'dangerousClassification': json['dangerousClassification'] == null ? undefined : json['dangerousClassification'],
        'dangerousPackingGroup': json['dangerousPackingGroup'] == null ? undefined : json['dangerousPackingGroup'],
        'dangerousProperShippingName': json['dangerousProperShippingName'] == null ? undefined : json['dangerousProperShippingName'],
        'dangerousTechnicalName': json['dangerousTechnicalName'] == null ? undefined : json['dangerousTechnicalName'],
        'dangerousNumberPackages': json['dangerousNumberPackages'] == null ? undefined : json['dangerousNumberPackages'],
        'dangerousPackagingType': json['dangerousPackagingType'] == null ? undefined : json['dangerousPackagingType'],
        'dangerousNetExplosiveQuantityKg': json['dangerousNetExplosiveQuantityKg'] == null ? undefined : json['dangerousNetExplosiveQuantityKg'],
    };
}

  export function LineItemToJSON(json: any): LineItem {
      return LineItemToJSONTyped(json, false);
  }

  export function LineItemToJSONTyped(value?: LineItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handlingUnitType': HandlingUnitTypeToJSON(value['handlingUnitType']),
        'numberHandlingUnits': value['numberHandlingUnits'],
        'description': value['description'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'weightPerHandlingUnit': value['weightPerHandlingUnit'],
        'freightClass': value['freightClass'],
        'temperatureHandling': TemperatureHandlingToJSON(value['temperatureHandling']),
        'isDangerous': value['isDangerous'],
        'nmfcItemNumber': value['nmfcItemNumber'],
        'isStackable': value['isStackable'],
        'lineItemId': value['lineItemId'],
        'dangerousUnNumber': value['dangerousUnNumber'],
        'dangerousClassification': value['dangerousClassification'],
        'dangerousPackingGroup': value['dangerousPackingGroup'],
        'dangerousProperShippingName': value['dangerousProperShippingName'],
        'dangerousTechnicalName': value['dangerousTechnicalName'],
        'dangerousNumberPackages': value['dangerousNumberPackages'],
        'dangerousPackagingType': value['dangerousPackagingType'],
        'dangerousNetExplosiveQuantityKg': value['dangerousNetExplosiveQuantityKg'],
    };
}

